import Vue from 'vue';
import Vant from 'vant'; // 2vant组件引入
import App from './App.vue';
import router from './router';
import store from './store';
import 'vant/lib/index.css'; // 2vant组件引入
import '@/assets/font/iconfont.css'; // 3引入iconfont.css
import '@/assets/css/style.css'; // 4引入公共样式
import './utils/rem';// 5将像素单元生成rem单位
import commonUrl from './utils/commonUrl';// 6公共访问链接比如oss
import apiFun from './utils/apiFun';// 7公共访问返参接口
import { wsDataInit } from './utils/wsdata_conf'
import infiniteScroll from 'vue-infinite-scroll'
Vue.use(infiniteScroll)
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

// 2存储
import storage from './utils/storage';

Vue.config.productionTip = false;
// 2存储
Vue.prototype.$storage = storage;
// 2vant组件引入
Vue.use(Vant);
// 6公共访问链接比如oss
Vue.prototype.$commonUrl = commonUrl;
// 7公共访问返参接口
Vue.prototype.$apiFun = apiFun;
// 调试
import Vconsole from 'vconsole';

if (window.location.origin != 'https://designated.wsecar.com') {
  const vConsole = new Vconsole();
  Vue.use(vConsole);
}

//神策
import { sensorsInit } from './utils/sensors';

try {
  // 初始化埋点配置
  sensorsInit();
  sensors.quick('autoTrack');
  wsDataInit()
  wsdata.quick("autoTrack");
} catch (error) {
  console.log(error);
}

//钩子登录拦截
router.beforeEach((to, from, next) => {
  //如果自定义了标题就取标题，否则拿全局标题
  window.document.title = to.meta.title !== undefined ? (to.meta.title) : Vue.prototype.appName;
  // window.document.title = to.meta.title !== undefined ? (to.meta.title + '-' + Vue.prototype.appName) : Vue.prototype.appName;
  next();
  wsdata.quick("autoTrackSinglePage");
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
